import { Link } from "@tanstack/react-router";
import { ArrowRight, ArrowUpRight, Sparkles } from "lucide-react";

const AION_URL = "https://aion.engineer";

/**
 * Conversion block routing site traffic (mostly people researching Raj) to the
 * Aion AI course. Rendered as plain SSR markup so the links are crawlable.
 */
export function AionCta({
  heading = "Learn the skill Raj keeps talking about",
  body = "Aion is a cinematic AI course built for founders, operators and students in India — prompt engineering, AI agents and the mental models behind real output. Entry is ₹11.",
  className = "",
  compact = false,
}: {
  heading?: string;
  body?: string;
  className?: string;
  /** Tighter inline variant for mid-page placement */
  compact?: boolean;
}) {
  return (
    <section
      aria-labelledby="aion-cta-heading"
      className={`mx-auto max-w-5xl px-6 ${compact ? "py-8" : "py-16"} ${className}`}
    >
      <div className="rounded-2xl border border-gold/30 bg-card p-6 md:p-8">
        <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-gold mb-4">
          <Sparkles size={14} /> Aion
        </div>
        <h2
          id="aion-cta-heading"
          className={`font-display font-semibold tracking-tight mb-3 ${
            compact ? "text-2xl" : "text-2xl md:text-3xl"
          }`}
        >
          {heading}
        </h2>
        <p className="text-muted-foreground leading-relaxed max-w-2xl">{body}</p>
        <div className="mt-6 flex flex-wrap items-center gap-3">
          <a
            href={AION_URL}
            target="_blank"
            rel="noopener"
            className="inline-flex items-center gap-2 rounded-lg bg-gold px-5 py-2.5 text-sm font-semibold text-noir hover:opacity-90 transition"
          >
            Join Aion for ₹11 <ArrowUpRight size={15} />
          </a>
          <Link
            to="/aion"
            className="inline-flex items-center gap-2 rounded-lg border border-border px-5 py-2.5 text-sm font-medium hover:border-gold/50 transition"
          >
            What Aion covers <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </section>
  );
}
